<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        title="Vælg standard beskrivelse"
        :large="true"
    >
        <div class="columns is-multiline is-tablet mb-1">
            <div class="column is-full">
                <List
                    v-if="items.length > 0"
                    table-classes="table is-fullwidth"
                    :columns="columns"
                    :data="items"
                    :page-length="50"
                    :pagination="false"
                    :rows-clickable="false"
                    :default-order="{ col: 'name', dir: 'asc' }"
                >
                    <template slot="column-actions" slot-scope="{ row }">
                        <button
                            class="button is-primary"
                            @click.stop="$emit('selected', row.description)"
                        >
                            Vælg
                        </button>
                    </template>
                </List>
                <span v-else class="list-empty">
                    <p>Ingen standard beskrivelser fundet.</p>

                    <hr />

                    <button
                        class="button is-primary"
                        @click.prevent="modalOpen = true"
                    >
                        Opret den første standard beskrivelse
                    </button>
                </span>
            </div>
        </div>

        <template v-slot:footer>
            <div class="footer-spacer">
                <button class="button is-default" @click="$emit('closed')">
                    Annuller
                </button>
            </div>
        </template>

        <DefaultDescriptionModal
            :active="modalOpen"
            @closed="closeModal"
            @created="getAll"
        />
    </modal>
</template>

<script>
import Modal from "@elems/modal";
import List from "@/elements/list";
import DefaultDescriptionModal from "../settings/projects/components/DefaultDescriptionModal.vue";

export default {
    components: {
        Modal,
        List,
        DefaultDescriptionModal,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        0;
        return {
            modalOpen: true,
            items: [],
            columns: [
                {
                    name: "name",
                    title: "Titel",
                    sortable: true,
                    searchable: true,
                    width: 20,
                },
                {
                    name: "description",
                    title: "Beskrivelse",
                    sortable: true,
                    searchable: true,
                },
                {
                    name: "actions",
                    title: "",
                    sortable: false,
                    searchable: false,
                    classes: () => "has-text-right",
                    width: "100px",
                },
            ],
        };
    },
    methods: {
        closeModal() {
            this.modalOpen = false;
        },
        getAll() {
            this.closeModal();
            window.axios.get("/api/default-descriptions").then(({ data }) => {
                this.items = data;
            });
        },
    },
    mounted() {
        this.getAll();
    },
};
</script>

<style lang="scss" scoped>
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.column {
    padding: 0 0.75rem;
}
</style>
